import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from '../../components/Card';

function PeoplePage() {
  const [people, setPeople] = useState(null); 
  const { persid } = useParams(); 
  const [relatedObjects, setRelatedObjects] = useState([]); 
  const uniqueObjectIds = new Set(); 
  const [loadingRelatedObjects, setLoadingRelatedObjects] = useState(true); 


  const fetchPeople = async () => {
    try {
      const response = await fetch(`/api/people/${persid}`);
      const jsonData = await response.json();
      setPeople(jsonData[0]); 

      const objectIds = jsonData[0].obj_id;
      for (const id of objectIds) {
        console.log(`Fetching related object with ID: ${id}`); 
        await fetchRelatedObject(id); 
      }
      
    } catch (err) {
      console.error(err.message);
    }
  };

 const fetchRelatedObject = async (id) => {
  try {
    const response = await fetch(`/api/item/${id}`);
    const jsonData = await response.json();

    const newObjects = Array.isArray(jsonData) ? jsonData : [jsonData];

    newObjects.forEach(newObj => {
      if (!uniqueObjectIds.has(newObj.obj_id)) {
        uniqueObjectIds.add(newObj.obj_id); 
        setRelatedObjects(prevObjects => [...prevObjects, newObj]); 
      }
    });

    setLoadingRelatedObjects(false);

    console.log("Updated relatedObjects:", relatedObjects);
  } catch (err) {
    console.error("Error fetching related objects:", err);
    setLoadingRelatedObjects(false); 
  }
};

  useEffect(() => {
    fetchPeople();
  }, [persid]);

  if (!people) {
    return <p>Loading...</p>;
  }

  return (
    <Fragment>
      <div className="detailpage">
      {people.pers_nick ? (
        <h1>{people.pers_nick}</h1>
      ) : (
        <h1>{people.pers_name}</h1>
      )}
      

      <div className="detailpage_desc">
      {people.pers_name !== null ? (
        <>
        <div className="detailpg_data_row">
        <h4 className="detailpg_title">Name: </h4> 
        <h4 >{people.pers_name}</h4>
        </div>
        </>
      ) : (
        <div className="na">No Data</div>
      )}
      
      {people.pers_bio ? (

        <div className="detailpg_data_row">
          <h4 className="detailpg_title">Bio:</h4>
          <h4 className="detailpg_value">{people.pers_bio}
          </h4>
          </div>
      ) : (
        <div className="na">No Data</div>
      )}
      {people.pers_url ? (
        <div className="detailpg_data_row">
        <h4 className="detailpg_title">Personal Site:</h4>
        <h4>
          <a href={people.pers_url} target="_blank" rel="noopener noreferrer">{people.pers_url}</a>
          </h4>
        </div>
      ) : (
        <div className="na">No Data</div>
      )}
</div>

      <h4 id="rel_title">Related Objects</h4>
      <div className="related-objects">
      <div className="container">
      <div className="wrapper">
      <div className="csrow">
              {relatedObjects.map(object => {
const media = object.media ? 'thumb_' + object.media.split(',')[0] : ''; 
                
                return (
                  <Card
                    key={object.obj_id}
                    id={object.obj_id}
                    ref_id={object.ref_id}
                    title={object.title}
                    media={media}  
                    media_type={object.med_name}
                    project={object.prj_name}
                    record_date={object.record_date ? new Date(object.record_date).toLocaleDateString() : 'No date available'}
                  />
                );
              })}
            </div>   
      </div>
      </div>
      </div>
      </div>
    </Fragment>
  );
}

export default PeoplePage;
